module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#facebook",
      toString: function () {
        return this.url;
      }
    }